import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  /** Cel odnośnika; null renderuje logo bez odnośnika. */
  href?: string | null;
  /**
   * `static` — pokazuje lockup (z tekstem) lub mark zależnie od `showText`.
   * `sidebar` — renderuje oba obrazy, swap na hover containera z klasą
   *             `group/sidebar` (collapsed → mark, expanded/hover → lockup).
   */
  variant?: "static" | "sidebar";
  showText?: boolean;
  size?: "sm" | "md" | "lg";
}

export function Logo({
  className,
  href = "/pulpit",
  variant = "static",
  showText = true,
  size = "md",
}: LogoProps) {
  const sizes = {
    sm: { mark: 28, lockup: { w: 96, h: 32 } },
    md: { mark: 36, lockup: { w: 120, h: 40 } },
    lg: { mark: 44, lockup: { w: 148, h: 48 } },
  };
  const s = sizes[size];

  if (variant === "sidebar") {
    // Oba obrazy w DOM, CSS przełącza widoczność wg stanu group/sidebar:hover
    const logo = (
      <>
        <Image
          src="/healsy-mark.svg"
          alt="Healsy"
          width={s.mark}
          height={s.mark}
          className="block group-hover/sidebar:hidden group-has-[:focus-visible]/sidebar:hidden group-data-[expanded=true]/sidebar:hidden"
          priority
        />
        <Image
          src="/healsy-lockup.svg"
          alt="Healsy"
          width={s.lockup.w}
          height={s.lockup.h}
          className="hidden group-hover/sidebar:block group-has-[:focus-visible]/sidebar:block group-data-[expanded=true]/sidebar:block"
          priority
        />
      </>
    );
    const wrapperClassName = cn(
      "flex items-center transition-opacity hover:opacity-90",
      className
    );

    return href === null ? (
      <span className={wrapperClassName}>{logo}</span>
    ) : (
      <Link href={href} className={wrapperClassName}>
        {logo}
      </Link>
    );
  }

  const logo = (
    <>
      {showText ? (
        <Image
          src="/healsy-lockup.svg"
          alt="Healsy"
          width={s.lockup.w}
          height={s.lockup.h}
          className="transition-transform group-hover:scale-105"
          priority
        />
      ) : (
        <Image
          src="/healsy-mark.svg"
          alt="Healsy"
          width={s.mark}
          height={s.mark}
          className="transition-transform group-hover:scale-105"
          priority
        />
      )}
    </>
  );
  const wrapperClassName = cn(
    "group flex items-center transition-opacity hover:opacity-90",
    className
  );

  return href === null ? (
    <span className={wrapperClassName}>{logo}</span>
  ) : (
    <Link href={href} className={wrapperClassName}>
      {logo}
    </Link>
  );
}
